import { create } from 'zustand';

import { EnrichedCustomer } from '@/models/EnrichedPrismicDocuments.ts';

interface PrismicConfigStore {
    customers: EnrichedCustomer[];
    instance_colors: Record<string, string>;
}

export const usePrismicConfigStore = create<PrismicConfigStore>(() => ({
    customers: [],
    instance_colors: {},
}));
